import { CalendarDays, CalendarHeart, Inbox, Menu, ShoppingCart, Sun, UtensilsCrossed } from "lucide-react";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../lib/db";
import { navigate, usePath } from "../lib/hooks";
import { cn } from "./ui";

/** PK: his planner first, with the shared shopping list. */
const OWNER_TABS = [
  { path: "/", label: "Vandaag", icon: Sun },
  { path: "/week", label: "Week", icon: CalendarDays },
  { path: "/taken", label: "Taken", icon: Inbox },
  { path: "/boodschappen", label: "Winkel", icon: ShoppingCart },
  { path: "/meer", label: "Meer", icon: Menu },
];

/** Tsjits (fase 2): what the two of them share, and her own agenda. */
const MEMBER_TABS = [
  { path: "/", label: "Winkel", icon: ShoppingCart },
  { path: "/menu", label: "Menu", icon: UtensilsCrossed },
  { path: "/agenda", label: "Agenda", icon: CalendarHeart },
  { path: "/meer", label: "Meer", icon: Menu },
];

export function BottomNav({ role }: { role: "owner" | "member" }) {
  const TABS = role === "member" ? MEMBER_TABS : OWNER_TABS;
  const path = usePath();
  const inboxCount =
    useLiveQuery(() =>
      db.tasks
        .where("status")
        .equals("inbox")
        .filter((t) => !t.deleted_at)
        .count(),
    ) ?? 0;
  return (
    <nav aria-label="Hoofdmenu" className="fixed inset-x-0 bottom-0 z-10 border-t border-mist bg-surface pb-[env(safe-area-inset-bottom)]">
      <ul className="mx-auto flex max-w-xl">
        {TABS.map(({ path: to, label, icon: Icon }) => {
          // A day opened from the Week belongs to the Week tab.
          const active =
            to === "/" ? path === "/" : path === to || path.startsWith(`${to}/`) || (to === "/week" && path.startsWith("/dag/"));
          const count = to === "/taken" ? inboxCount : 0;
          return (
            <li key={to} className="flex-1">
              <a
                href={to}
                aria-current={active ? "page" : undefined}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(to);
                }}
                className={cn(
                  "flex min-h-16 flex-col items-center justify-center gap-0.5 text-xs [overflow-wrap:anywhere] sm:text-sm",
                  active ? "font-semibold text-pine" : "text-ink-soft",
                )}
              >
                <span className="relative">
                  <Icon aria-hidden className="size-6" strokeWidth={active ? 2.4 : 1.8} />
                  {count > 0 && (
                    <span className="absolute -top-1.5 -right-3 min-w-5 rounded-full bg-pine px-1 text-center text-xs leading-5 font-semibold text-paper tabular">
                      {count}
                    </span>
                  )}
                </span>
                {label}
                {count > 0 && <span className="sr-only">, {count} nieuw bij Taken</span>}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
